import { Link } from 'react-router-dom';

export default function AdminPage() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold text-gray-900">Admin</h1>
        <p className="mt-2 text-gray-600">
          Administrative tools for access control and system-level configuration.
        </p>
      </div>

      <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
        <h2 className="text-lg font-semibold text-gray-900">User Access Management</h2>
        <p className="mt-2 text-sm text-gray-600">
          Add users, update roles, and remove access for users who should no longer use the app.
        </p>

        <div className="mt-4">
          <Link
            to="/admin/allowed-users"
            className="inline-flex items-center px-4 py-2 bg-brand-600 text-white font-medium rounded-lg hover:bg-brand-700 transition-colors"
          >
            Go to Manage Users
          </Link>
        </div>
      </div>
    </div>
  );
}